/*
 * View for the decision choice area, where decision choice labels can be assigned,
 * along with translations.  Holds a sortable list for multi-language support
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicDecisionArea/template/topicDecisionAreaTemplate.html",
], function (Marionette, TopicDecisionAreaTemplate) {
  var TopicDecisionAreaView = {};

  TopicDecisionAreaView.topicDecisionAreaLayout = Marionette.Layout.extend({
    template: TopicDecisionAreaTemplate,
    regions: {
      decisionLabelList: "#decisionLabelList",
    },
    textboxes: {
      "#englishLabelText": {
        enableSelector: "#englishLabel",
        modelAttribute: "description",
        textArea: false,
      },
    },
  });

  return TopicDecisionAreaView;
});
